import { Share2 } from "lucide-react";
import { toast } from "sonner";

export default function ShareButton({ title, path = "", testId, className = "" }) {
    const share = async () => {
        const url = `${window.location.origin}${path}`;
        if (navigator.share) {
            try {
                await navigator.share({ title, url });
                return;
            } catch (e) {
                if (e?.name === "AbortError") return;
            }
        }
        const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        const win = window.open(fb, "_blank", "noopener,noreferrer,width=600,height=520");
        if (!win) {
            await navigator.clipboard?.writeText(url);
            toast.success("Link copied — paste it anywhere!");
        }
    };

    return (
        <button
            type="button"
            onClick={share}
            data-testid={testId}
            aria-label={`Share ${title}`}
            className={`inline-flex items-center gap-2 rounded-full border border-[#3D2318]/15 bg-white/70 px-5 py-2.5 text-sm font-semibold text-[#3D2318] hover:border-[#C95B7D] hover:text-[#C95B7D] transition-[border-color,color] duration-300 ${className}`}
        >
            <Share2 className="h-4 w-4" />
            Share
        </button>
    );
}
